var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line"},[_vm._v("\n\t© 2016 深圳聚客网络科技有限公司 | All Rights Reserved. 备案号：粤ICP备17017799号-2\n")])}
var staticRenderFns = []

export { render, staticRenderFns }